import styled from 'styled-components';
import animPulse from '../../../helpers/animPulseSmall';

const shareWidth = '25px';

export const ShareButtonWrap = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  left: 50%;
  position: absolute;
  top: -14px;
  transform: translateX(-50%);
  width: 160px;
`;

export const SVG = styled.svg`
  fill: ${props => (props.facebook ? '#0084FF' : '#0084b4')};
  height: 15px;
  width: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: fill ${props => props.theme.transition.durationLong}
    ${props => props.theme.transition.easeOut};
`;

const ShareButtonStyled = styled.a`
  animation: ${animPulse} 0.5s ease-out infinite;
  background: ${props => props.theme.colors.white};
  border-radius: 100%;
  height: ${shareWidth};
  margin-bottom: 20px;
  position: relative;
  width: ${shareWidth};
  transition: background ${props => props.theme.transition.durationLong}
    ${props => props.theme.transition.easeOut};

  &:hover {
    background: ${props => (props.facebook ? '#0084FF' : '#0084b4')};
    svg {
      fill: ${props => props.theme.colors.white};
    }
  }
`;

export default ShareButtonStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/ShareButton/ShareButton.styled.js